import styled from '@emotion/styled';

const BRAND = '#0078d4';
const BORDER = '#e1dfdd';
const TEXT = '#323130';
const TEXT_SOFT = '#605e5c';

const StyledFullCalendar = styled('div')`
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont,
    Roboto, 'Helvetica Neue', sans-serif;
  width: 100%;
  min-width: 0;

  /* El contenedor .fc (fc fc-media-screen fc-direction-ltr fc-theme-standard)
     es el que define los breakpoints: se usan container queries sobre su
     ancho real en lugar de media queries sobre el viewport/body. */
  .fc {
    container-type: inline-size;
    container-name: fc-calendar;
  }

  /* =====================================================================
     TOOLBAR
     ===================================================================== */
  .fc .fc-header-toolbar.fc-toolbar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    grid-template-areas: 'left center right';
    align-items: center;
    gap: 12px 16px;
    margin-bottom: 12px;
    padding: 8px 4px;
  }

  .fc .fc-toolbar-chunk {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    min-width: 0;
  }
  .fc .fc-toolbar-chunk:nth-of-type(1) { grid-area: left; justify-content: flex-start; }
  .fc .fc-toolbar-chunk:nth-of-type(2) { grid-area: center; justify-content: center; }
  .fc .fc-toolbar-chunk:nth-of-type(3) { grid-area: right; justify-content: flex-end; }

  /* Título (mes / semana) */
  .fc .fc-toolbar-title {
    margin: 0;
    font-size: clamp(1rem, 0.85rem + 0.6vw, 1.4rem);
    font-weight: 600;
    color: ${TEXT};
    white-space: nowrap;
    text-transform: capitalize;
    line-height: 1.2;
  }

  /* ---- Botones base ---- */
  .fc .fc-button,
  .fc .fc-button-primary {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    min-height: 34px;
    padding: 0 14px !important;
    font-size: 14px !important;
    border-radius: 6px !important;
    border: 1px solid ${BORDER} !important;
    background-color: #fff !important;
    color: ${TEXT} !important;
    transition: background-color 0.15s ease, border-color 0.15s ease;
  }
  .fc .fc-button-primary:not(:disabled):hover {
    background-color: #f3f2f1 !important;
  }
  .fc .fc-button-primary:focus-visible {
    outline: 2px solid ${BRAND} !important;
    outline-offset: 1px;
  }
  .fc .fc-button-primary:disabled {
    opacity: 0.5;
  }

  /* Prev / Next */
  .fc .fc-prev-button,
  .fc .fc-next-button {
    width: 34px;
    padding: 0 !important;
  }
/*   .fc .fc-button-group > .fc-button:not(:first-of-type) {
    margin-left: -1px;
  } */

  /* Hoy */
  .fc .fc-today-button {
    font-weight: 600 !important;
  }

  /* Grupo de vistas: control segmentado */
  .fc .fc-toolbar-chunk:first-child .fc-button-group  {
    flex-wrap: nowrap;
  }
  .fc .fc-toolbar-chunk:nth-of-type(3) .fc-button-group {
    display: inline-flex;
    flex-wrap: nowrap;
    padding: 3px;
    gap: 2px;
    background: #f3f2f1;
    border-radius: 8px;
  }
  .fc .fc-toolbar-chunk:nth-of-type(3) .fc-button-group > .fc-button {
    margin-left: 0;
    border: 0 !important;
    border-radius: 6px !important;
    background-color: transparent !important;
    color: ${TEXT_SOFT} !important;
    min-height: 30px;
    text-transform: capitalize;
  }
  .fc .fc-toolbar-chunk:nth-of-type(3) .fc-button-group > .fc-button.fc-button-active {
    background-color: #fff !important;
    color: ${BRAND} !important;
    font-weight: 600 !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12) !important;
  }

  .fc .fc-toolbar-chunk:nth-of-type(3) .fc-button-group > .fc-button:hover{
    background-color: #fff !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12) !important;
  }

  /* Botón "Horas pendientes del mes" (customLabel): tarjeta informativa */
  .fc .fc-customLabel-button {
    cursor: default !important;
    min-height: 40px;
    padding: 2px 12px !important;
    font-size: 12px !important;
    line-height: 1.25;
    white-space: nowrap;
  }
  .fc .fc-customLabel-button:not(:disabled):hover{
    background-color: #fff !important;
  }
  .fc .fc-customLabel-button:empty {
    display: none !important;
  }
  .fc .fc-customLabel-button b {
    font-size: 14px;
    color: ${BRAND};
  }

  /* Botón estado de horas (hoursMiniPanel) */
  .fc .fc-hoursMiniPanel-button {
    /* width: 44px;
    padding: 0 !important; */
    margin: 0 !important;
  }
  .fc .fc-hoursMiniPanel-button #callout-hours-status {
    display: inline-flex;
    align-items: center;
    top: 0;
  }
  .fc .fc-hoursMiniPanel-button .text-icon-toolbar {
    top: 0;
    margin-right: 2px;
    font-size: 17px;
  }

  /* Botón vacío generado por comas sobrantes en headerToolbar */
  .fc .fc--button {
    display: none !important;
  }

  /* =====================================================================
     GRILLA / EVENTOS
     ===================================================================== */
  .fc .fc-scrollgrid {
    border-radius: 6px;
    overflow: hidden;
  }

  .fc .fc-col-header-cell-cushion {
    padding: 6px 4px;
    color: ${TEXT};
    text-decoration: none;
    text-transform: capitalize;
  }

  /* .fc .fc-day-today {
    background-color: rgba(0, 120, 212, 0.05) !important;
  } */

  .fc-event-main {
    border: none !important;
    background-color: ${BRAND};
    border-radius: 2px;
    color: #000 !important;
    font-size: 11px;
  }

  .fc-event-main-frame {
    font-weight: 600;
    letter-spacing: 0.02rem;
    margin-left: 4px;
  }

  .fc .fc-bg-event {
    background: #fbf2dc !important;
    opacity: 1;
  }

  .fc-event {
    border: none !important;
    background-color: #71afe5 !important;
    border-radius: 2px;
    color: #080d12 !important;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.02rem;
    margin-left: 4px;
  }

  .fc-event-main:has(.pending-event) {
    background-color: #ff4856 !important;
  }
  .fc-event-main:has(.outlook-event) {
    background-color: #ddd500 !important;
  }
  .fc-event-main:has(.deleted-event) {
    background-color: #888 !important;
  }

  .fc-timegrid-event .fc-event-main {
    padding: 0 0 0 6px;
  }

  /* Alto del área con scroll */
  .fc-scrollgrid-section-body td .fc-scroller-harness {
    height: 70vh;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch;
  }
  @container fc-calendar (min-width: 1001px) {
    @media (min-height: 911px) {
      .fc-scrollgrid-section-body td .fc-scroller-harness {
        height: 80vh;
      }
    }
  }

  .fc-daygrid-body,
  .fc-daygrid-body table,
  .fc-daygrid-body table tbody {
    height: inherit;
  }

  /* Vista lista */
  .fc .fc-list-day-cushion {
    text-transform: capitalize;
  }

  /* Restos de FullCalendar v4 (timeline) */
  td.fc-widget-content {
    height: 75px;
    .fc-event-container {
      padding: 0;
      top: 0;
    }
    .fc-timeline-event {
      padding: 0;
      margin: 0;
      border: 0;
      background-color: transparent;
    }
  }
  .fc-resource-area td.fc-widget-content {
    vertical-align: middle;
  }

  section {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    margin-left: 20px;
    span {
      padding: 4px 0;
    }
  }

  /* =====================================================================
     TABLET (contenedor ≤ 1000px): vistas en su propia fila
     ===================================================================== */
  @container fc-calendar (max-width: 1000px) {
    .fc .fc-header-toolbar.fc-toolbar {
      grid-template-columns: auto minmax(0, 1fr);
      grid-template-areas:
        'left   center'
        'right  right';
    }
    .fc .fc-toolbar-chunk:nth-of-type(2) {
      justify-content: flex-end;
    }
    .fc .fc-toolbar-chunk:nth-of-type(3) {
      justify-content: center;
    }
  }

  /* =====================================================================
     MÓVIL (contenedor < 768px)
     ===================================================================== */
  @container fc-calendar (max-width: 767.98px) {
    .fc .fc-header-toolbar.fc-toolbar {
      grid-template-columns: minmax(0, 1fr);
      grid-template-areas:
        'center'
        'left'
        'right';
      gap: 10px;
      padding: 4px 0;
      margin-bottom: 8px;
    }

    /* Fila 1: Hoy · Título · Estado horas */
    .fc .fc-toolbar-chunk:nth-of-type(2) {
      justify-content: space-between;
    }
    .fc .fc-toolbar-title {
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      font-size: 1.05rem;
    }

    /* Fila 2: Prev/Next · Horas pendientes */
    .fc .fc-toolbar-chunk:nth-of-type(1) {
      justify-content: space-between;
    }
    .fc .fc-customLabel-button {
      flex: 1 1 auto;
      min-width: 0;
      white-space: normal;
      text-align: center;
      font-size: 11px !important;
    }

    /* Fila 3: Vistas a todo el ancho */
    .fc .fc-toolbar-chunk:nth-of-type(3) .fc-button-group {
      display: flex;
      width: 100%;
    }
    .fc .fc-toolbar-chunk:nth-of-type(3) .fc-button-group > .fc-button {
      flex: 1 1 0;
      padding: 0 4px !important;
      font-size: 13px !important;
      min-height: 36px;
    }

    /* Objetivos táctiles más cómodos */
    .fc .fc-button,
    .fc .fc-button-primary {
      min-height: 40px;
    }
    .fc .fc-prev-button,
    .fc .fc-next-button {
      width: 40px;
    }

    /* Grilla más compacta */
    .fc .fc-col-header-cell-cushion {
      padding: 4px 1px;
      font-size: 11px;
      white-space: normal;
      line-height: 1.15;
    }
    .fc .fc-timegrid-axis-cushion,
    .fc .fc-timegrid-slot-label-cushion {
      font-size: 10px;
      padding: 0 2px;
    }
    .fc .fc-daygrid-day-number {
      font-size: 12px;
      padding: 2px 4px;
    }
    .fc-event {
      margin-left: 1px;
      font-size: 9px;
    }
    .fc-event-main-frame {
      margin-left: 2px;
    }

    .fc-scrollgrid-section-body td .fc-scroller-harness {
      height: calc(100vh - 300px);
      height: calc(100dvh - 300px);
      min-height: 360px;
    }

    section {
      margin-left: 8px;
    }
  }

  /* Contenedor muy angosto (≤ 360px) */
  @container fc-calendar (max-width: 360px) {
    .fc .fc-toolbar-chunk:nth-of-type(3) .fc-button-group > .fc-button {
      font-size: 12px !important;
    }
    .fc .fc-today-button {
      padding: 0 10px !important;
    }
  }
`;

export default StyledFullCalendar;
